import React from 'react';
import { Box, Typography } from '@mui/material';

export const ReceiptsPage: React.FC = () => {
    return (
        <Box>
            <Typography variant="h4" component="h1" gutterBottom>
                Boletas
            </Typography>
            <Typography variant="body1">
                Gestión de boletas - En desarrollo
            </Typography>
        </Box>
    );
}; 